module.exports = __webpack_public_path__ + "img/form-8.4e1d50ea.svg";